<script setup lang="ts">
// we need this in order to have the component generate a name for itself. see <Section />
defineProps<{
  mama?: string
}>()
</script>
<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <Share />
    </div>
  </Section>
</template>
